import React from 'react';
import { ConfirmModal } from '@/app/components/ConfirmModal';
import TrashIcon from '/public/icons/trash.svg';

interface ConfirmationDeleteFileModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete?: () => void;
}

export const ConfirmationDeleteFileModal = ({ isOpen, onClose, onDelete }: ConfirmationDeleteFileModalProps) => {
  const handleConfirm = () => {
    onDelete?.();
    onClose();
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      panelClassName="gap-11.5"
      title="Delete an uploaded document"
      description="This will permanently remove the document from this client profile."
      confirmLabel="Delete"
      confirmIcon={<TrashIcon />}
    />
  );
};
